import {
  AuthState,
  clearLoginError,
  setUserData,
  signinAsync
} from '../app/reducer/auth.reducer';
import React, {useEffect} from 'react';
import { useDispatch, connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { useForm, SubmitHandler } from "react-hook-form";
import { ENCON_LOGO, LOGIN_BG } from '../assets';

import { Typography, TextField, Paper, Button, Container, makeStyles, CircularProgress } from '@material-ui/core';
import ChangePasswordDialog from '../components/ChangePasswordDialog';
type AuthFormProps = {
  busy: boolean;
  loginError: {
    email?: string;
    password?: string;
    general?: string;
  } | null;
};
interface IRootState{
  auth: AuthState;
}

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

type Inputs = {
  email: string,
  password: string
};

const useStyles = makeStyles((theme) => ({
    loginBox: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '400px',
      padding: theme.spacing(1)
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    input: {
        margin: theme.spacing(3, 0, 0)
    },
    submit: {
      margin: theme.spacing(3, 0, 2)
    },
  }));
  
export function AuthForm(props:AuthFormProps):JSX.Element {
  console.log(props);
const { register, handleSubmit, setError, clearErrors, formState: { errors } } = useForm<Inputs>();
  const dispatch = useDispatch()
  const classes = useStyles();
  const [changePasswordOpen, setChangePasswordOpen] = React.useState(false);
  useEffect(() => {
    if (props.loginError?.email) {
      setError("email", {
        type: "server",
        message: props.loginError.email
      });
    }

    if (props.loginError?.password) {
      setError("password", {
        type: "server",
        message: props.loginError.password
      });
    }
  }, [props.loginError, setError]);

  const onSubmit: SubmitHandler<Inputs> = data => {
    clearErrors();
    dispatch(clearLoginError());
    dispatch(signinAsync(data) as any);
  };

  return (
    <Paper className={classes.loginBox}>
        <img src={ENCON_LOGO} style={{height:'200px', width:'200px'}}/>
        <Typography component="h1" variant="h5">
          FAN SELECTION TOOL
        </Typography>
        {props.loginError?.general && (
          <Typography color="error" style={{ marginTop: 10 }}>
            {props.loginError.general}
          </Typography>
        )}
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
            <TextField
                label="Email Address"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: EMAIL_REGEX,
                    message: "Please enter valid email"
                  }
                })}
                variant="outlined"
                error={(errors.email?true:false)}
                helperText={errors.email?.message || ''}
                className={classes.input}
              />
            <TextField
                label="Password"
                {...register("password", {
                  required: "Please enter password"
                })}
                variant="outlined"
                type="password"
                error={(errors.password?true:false)}
                helperText={errors.password?.message || ''}
                className={classes.input}
            />
          {props.busy?
            <Button
                variant="contained" color="primary"
                onClick={(e)=>e.preventDefault()}
                className={classes.submit}
                fullWidth size="large"
            >
              <CircularProgress 
              size={26}
              />
            </Button>
            :
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.submit}
              fullWidth size="large"
            >
                Sign In
            </Button>
          }
          <Button
            size="small"
            color="default"
            style={{ marginTop: 4, textTransform: 'none' }}
            onClick={() => setChangePasswordOpen(true)}
          >
            Change Password
          </Button>
        </form>
      <ChangePasswordDialog
        open={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
      />
    </Paper>
  )
}

export class Login extends React.Component<IRootState, {}> {
  render() {
  let { busy,isAuth } = this.props.auth;
  console.log(this.props.auth)
  if (isAuth === true) {
    return <Redirect push to="/" />;
  }

    return (
        <Container maxWidth="sm" className="form-wrapper" style={{overflowY:'hidden'}}>
            <AuthForm busy={busy} loginError={this.props.auth.loginError} />
        </Container>
    );
  }
}

const mapStateToProps = ( state: IRootState, ownProps = {} ) => ({
  auth: state.auth
});

export default connect(mapStateToProps)(Login)